import { AppAreaConfig } from '@/funnels/@types'
import yogaFemale from '../yoga/activity-female-yoga'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-chair-tai-chi-fwf',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-f', 'age-chair-tai-chi-f'],
		route: {
			path: '/chair-tai-chi-f-fwf',
			name: 'female-chair-tai-chi-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-chair-fwf',
		route: {
			path: '/chair-tai-chi-f-fwf/ob/:page*',
			name: 'activity-female-chair-tai-chi-fwf',
		},
		slug: 'activity-female-chair-tai-chi-fwf',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: yogaFemale,
				page: 'physical-build',
			},
		},
	},
}

export default appAreaConfig
